import React from "react";
import Request from "request";
import clone from "lodash.clonedeep";
import locale from "locale";
import {
    Row,
    Col,
    Table,
    Modal,
    Button,
    FormGroup,
    InputGroup,
    FormControl,
    Glyphicon,
    ControlLabel,
    ButtonToolbar,
} from "react-bootstrap";

import {
    requestGetRecepients,
    requestAppendRecepients,
    requestDeleteRecepient,
} from "../../../../../../api/cp";
import ReminderRecipientsModalSheet from "./Sheet";

const ReminderRecipientsModal = ({
    isRecipientsModalVisible,
    reminder,
    onClose,
}) => {
    const [recipients, setRecepients] = React.useState([]);
    const [appendRecipientEmail, setAppendRecipientEmail] = React.useState("");
    const [sheets, setSheets] = React.useState(null);

    React.useEffect(() => {
        handleAddRecepients();
    }, [reminder.id]);

    async function handleAddRecepients() {
        try {
            const response = await requestGetRecepients(reminder.id);

            setRecepients(response);
        } catch (error) {
            alert(
                error?.error?.message ??
                    error?.message ??
                    "Error handleAddRecepients"
            );
        }
    }

    function showReceiversFileRequest() {
        const fileInput = document.createElement("input");
        fileInput.setAttribute("type", "file");
        fileInput.setAttribute(
            "accept",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        fileInput.addEventListener(
            "change",
            async ({ target }) => {
                const file = target.files[0];

                if (!file) {
                    console.error("File not select");
                    return;
                }

                const sheets = await Request.post(`/api/cp/excel/parseFile`, {
                    file,
                });
                setSheets(sheets);
            },
            false
        );
        fileInput.click();
    }

    async function removeRecipient(recipientId) {
        await requestDeleteRecepient(recipientId);
        const clonedRecipients = clone(recipients);
        const index = clonedRecipients.findIndex(
            ({ id }) => id === recipientId
        );
        clonedRecipients.splice(index >>> 0, 1);
        setRecepients(clonedRecipients);
    }

    async function handleAppendRecipient() {
        if (!/(.+)@(.+)(\.)(.+)/gi.test(appendRecipientEmail)) {
            alert(locale("reminders.emailError"));
            return;
        }

        await requestAppendRecepients(reminder.id, {
            emails: [appendRecipientEmail],
        });
        await handleAddRecepients();
        setAppendRecipientEmail("");
    }

    async function handleSheetApply(emails) {
        await requestAppendRecepients(reminder.id, {
            emails,
        });
        await handleAddRecepients();
        setSheets(null);
    }

    function renderManualMailingContent() {
        return (
            <>
                <Row>
                    <Col xs={12}>
                        <Button onClick={showReceiversFileRequest}>
                            {locale("reminders.uploadEmailsFromExcel")}
                        </Button>
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col xs={12}>
                        <FormGroup>
                            <ControlLabel>
                                {locale("reminders.email")}
                            </ControlLabel>
                            <InputGroup>
                                <FormControl
                                    type="email"
                                    value={appendRecipientEmail}
                                    placeholder="email@example.com"
                                    onChange={({ target }) =>
                                        setAppendRecipientEmail(target.value)
                                    }
                                />
                                <InputGroup.Button>
                                    <Button
                                        disabled={!appendRecipientEmail}
                                        onClick={handleAppendRecipient}
                                    >
                                        {locale("reminders.add")}
                                    </Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                {recipients.length > 0 && (
                    <Row style={{ marginTop: "15px" }}>
                        <Col xs={12}>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>eMail</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recipients.map((recipient, index) => (
                                        <tr key={index}>
                                            <td>{recipient.email}</td>
                                            <td style={{ textAlign: "right" }}>
                                                <Button
                                                    onClick={() =>
                                                        removeRecipient(
                                                            recipient.id
                                                        )
                                                    }
                                                >
                                                    <Glyphicon glyph="trash" />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                )}
            </>
        );
    }

    function renderSheet() {
        return (
            <ReminderRecipientsModalSheet
                sheets={sheets}
                onApply={handleSheetApply}
            />
        );
    }

    return (
        <Modal show={isRecipientsModalVisible} bsSize="large">
            <Modal.Header>
                <Modal.Title>{locale("reminders.mailing")}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {sheets ? renderSheet() : renderManualMailingContent()}
            </Modal.Body>

            <Modal.Footer>
                <ButtonToolbar style={{ float: "right" }}>
                    <Button onClick={onClose}>
                        {locale("reminders.close")}
                    </Button>
                </ButtonToolbar>
            </Modal.Footer>
        </Modal>
    );
};

export default ReminderRecipientsModal;
